import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { VaultChipRow } from "../components/VaultChipRow";
import { TabBar } from "../components/TabBar";
import { useVault } from "../contexts/VaultContext";

export default function Ask() {
  const { selected, toggle } = useVault();
  const navigate = useNavigate();
  const [question, setQuestion] = useState("");
  const [suggestions, setSuggestions] = useState<string[]>([]);

  useEffect(() => {
    const v = selected[0] ?? "main";
    fetch(`/api/suggestions?vault=${v}`)
      .then(r => r.ok ? r.json() as Promise<string[]> : [])
      .then(setSuggestions)
      .catch(() => setSuggestions([]));
  }, [selected]);

  const submit = (q: string) => {
    if (!q.trim()) return;
    const id = crypto.randomUUID();
    sessionStorage.setItem(`pending:${id}`, JSON.stringify({ question: q, vaults: selected }));
    navigate(`/answer/${id}`);
  };

  return (
    <div className="min-h-screen pb-20 px-4 pt-3">
      <h1 className="text-attic-accent font-bold text-base mb-3">attic</h1>
      <div className="flex gap-2 mb-3">
        <input
          value={question}
          onChange={e => setQuestion(e.target.value)}
          onKeyDown={e => { if (e.key === "Enter") submit(question); }}
          placeholder="Ask anything…"
          className="flex-1 bg-attic-surface border border-attic-border rounded-2xl px-4 py-3 text-sm"
        />
        <button
          onClick={() => submit(question)}
          disabled={!question.trim()}
          className="bg-attic-accent text-white font-semibold rounded-2xl px-5 text-sm disabled:opacity-40 disabled:cursor-not-allowed"
          aria-label="Submit question"
        >
          Ask
        </button>
      </div>
      <VaultChipRow selected={selected} onToggle={toggle} />
      <p className="text-[10px] uppercase font-bold text-attic-dim tracking-wider mt-4 mb-2">Suggested</p>
      {suggestions.filter(Boolean).map((s, i) => (
        <button
          key={i}
          onClick={() => submit(s)}
          className="w-full bg-attic-surface border border-attic-border rounded-xl px-4 py-3 text-sm text-left mb-2 flex items-center gap-2"
        >
          <span className="text-attic-accent">✦</span>
          <span className="flex-1">{s}</span>
          <span className="text-attic-dim">›</span>
        </button>
      ))}
      <TabBar />
    </div>
  );
}
